import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'wb-platform-settings',
});

export const practiceShaperRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-practice-shaper',
  parent: rootRouteRef,
  path: '/practice-shaper/*',
});

export const importPracticeShaperRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-practice-shaper-import',
  parent: rootRouteRef,
  path: '/practice-shaper/import',
});

export const graphPracticeShaperRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-practice-shaper-graph',
  parent: rootRouteRef,
  path: '/practice-shaper/graph',
});

export const supervisionRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-supervision',
  parent: rootRouteRef,
  path: '/supervision/*',
});

export const dynamicConfigRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-dynamic-config',
  parent: rootRouteRef,
  path: '/dynamic-config/*',
});

export const accessControlRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-access-control',
  parent: rootRouteRef,
  path: '/access-control',
});

export const customViewManagementRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-custom-view',
  parent: rootRouteRef,
  path: '/custom-view/*',
});

export const customViewDetailRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-custom-view-detail',
  parent: rootRouteRef,
  path: '/custom-view/:pageId',
});

export const customizationEditorRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-custom-view-editor',
  parent: rootRouteRef,
  path: '/custom-view/editor/:id',
});

export const builderToolsSkeletonRenderingPreviewRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-builder-tools-skeleton-rendering-preview',
  parent: rootRouteRef,
  path: '/builder-tools/skeleton-rendering-preview',
});

export const eventsDownloadRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-events-download',
  parent: rootRouteRef,
  path: '/events-download',
});

export const modulesRouteRef = createSubRouteRef({
  id: 'wb-platform-settings-modules',
  parent: rootRouteRef,
  path: '/modules',
});

export const iamRouteRef = createSubRouteRef({
  id: 'iam',
  parent: rootRouteRef,
  path: '/iam',
});

export const templateIndexRouteRef = createSubRouteRef({
  id: 'templates',
  parent: rootRouteRef,
  path: '/templates',
});

export const templateImportRouteRef = createSubRouteRef({
  id: 'template-import',
  parent: rootRouteRef,
  path: '/templates/import',
});

export const actionsRouteRef = createSubRouteRef({
  id: 'actions',
  parent: rootRouteRef,
  path: '/templates/actions',
});

export const templateEditorRouteRef = createSubRouteRef({
  id: 'template-studio',
  parent: rootRouteRef,
  path: '/templates/template-studio',
});

export const taskRouteRef = createSubRouteRef({
  id: 'task',
  parent: rootRouteRef,
  path: '/templates/tasks/:taskId',
});

export const taskListRouteRef = createSubRouteRef({
  id: 'list-tasks',
  parent: rootRouteRef,
  path: '/templates/tasks',
});
